/**
 * QuickAddTypeChips — the horizontal type selector in the modal.
 *
 * Each chip lights up in the type's accent color when it's the
 * active selection (either explicit user choice OR AI suggestion).
 * The `isExplicit` distinction drives the subtle opacity bump that
 * separates "user committed" from "AI guessed".
 */
import { TYPES } from './typeConfig';

export function QuickAddTypeChips({ effectiveType, explicitType, onSelectType }) {
  return (
    <div className="px-5 pb-3" data-testid="quickadd-types">
      <div className="flex flex-wrap gap-1.5">
        {TYPES.map((t) => {
          const Icon = t.icon;
          const isActive = effectiveType === t.key;
          const isExplicit = explicitType === t.key;
          return (
            <button
              key={t.key}
              type="button"
              data-testid={`quickadd-type-${t.key}`}
              onClick={() => onSelectType(t.key)}
              className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-full text-[11px] font-medium transition-all"
              style={{
                background: isActive ? t.accent : 'var(--pd-panel-2)',
                color: isActive ? '#fff' : 'var(--pd-text)',
                border: '1px solid ' + (isActive ? t.accent : 'var(--pd-border)'),
                opacity: isExplicit ? 1 : (isActive ? 0.92 : 1),
              }}
              aria-pressed={isActive}
            >
              <Icon className="w-3 h-3" />
              {t.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
